export enum QualifierStatusEnum {
  UploadPending = 0,
  UploadComplete = 1,
  Processing = 2,
  Processed = 3,
  Error = 4
}
